module.exports = __webpack_public_path__ + "img/account_inner_white.cc3cc5a0.svg";